import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js/instance/for-each";
import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _flatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/flat";
import _Object$entries from "@babel/runtime-corejs3/core-js/object/entries";
import React from "react";
export const withClasses = function (defaultCssModule) {
  let {
    propName = 'classes'
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  const decorator = Component => {
    const ComponentWithCSSModule = _ref => {
      let {
        [propName]: givenClasses,
        ...props
      } = _ref;
      const classes = givenClasses || defaultCssModule;
      let finalCssModules = classes;

      if (typeof classes === 'function') {
        finalCssModules = classes(defaultCssModule);
      }

      const newProps = { ...props,
        [propName]: finalCssModules
      };
      return /*#__PURE__*/React.createElement(Component, newProps);
    };

    ComponentWithCSSModule.displayName = `WithCSSModule(${Component.displayName || Component.name || 'Unknown'})`;
    return ComponentWithCSSModule;
  };

  return decorator;
};

const replaceClassNameReducer = (_, newClassName) => newClassName;

const combineClassNameReducer = function () {
  let previousClassName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  let newClassName = arguments.length > 1 ? arguments[1] : undefined;
  return `${previousClassName} ${newClassName}`;
};

const createNewCssModule = (defaultCssModule, newCssModule, classNameReducer) => {
  var _context;

  const finalCssModule = { ...defaultCssModule
  };

  _forEachInstanceProperty(_context = _Object$keys(newCssModule)).call(_context, classIdentifier => {
    const previousClassName = finalCssModule[classIdentifier];
    const newClassName = newCssModule[classIdentifier];
    finalCssModule[classIdentifier] = classNameReducer(previousClassName, newClassName);
  });

  return finalCssModule;
};

export const compose = newCssModule => {
  const composeMapper = defaultCssModule => createNewCssModule(defaultCssModule, newCssModule, combineClassNameReducer);

  return composeMapper;
};
export const replace = newCssModule => {
  const replaceMapper = defaultCssModule => createNewCssModule(defaultCssModule, newCssModule, replaceClassNameReducer);

  return replaceMapper;
};
export const useClasses = function () {
  for (var _len = arguments.length, cssModules = new Array(_len), _key = 0; _key < _len; _key++) {
    cssModules[_key] = arguments[_key];
  }

  if (cssModules[0] === undefined) {
    throw new Error('Base css module is undefined. This is not allowed');
  }

  return React.useMemo(() => {
    const normalizedCssModuleList = _filterInstanceProperty(cssModules).call(cssModules, el => el !== undefined);

    return _reduceInstanceProperty(normalizedCssModuleList).call(normalizedCssModuleList, (last, next) => {
      if (typeof next === 'function') {
        return next(last);
      }

      return next;
    });
  }, cssModules);
};
export const useClassesMapper = function (mapper) {
  for (var _len2 = arguments.length, cssModules = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    cssModules[_key2 - 1] = arguments[_key2];
  }

  if (typeof mapper !== 'function') {
    throw new Error(`Expected first argument to be a mapper function. This should be the result of calling 
#compose or #replace`);
  }

  return React.useMemo(() => {
    const normalizedCssModuleList = _filterInstanceProperty(cssModules).call(cssModules, el => el !== undefined);

    return _reduceInstanceProperty(normalizedCssModuleList).call(normalizedCssModuleList, (lastMapper, next) => defaultCssModule => {
      if (typeof next === 'function') {
        return next(lastMapper(defaultCssModule));
      }

      return next;
    }, mapper);
  }, [mapper, ...cssModules]);
};
export const useClassesCompose = newClasses => {
  var _context2;

  return React.useCallback(compose(newClasses), _flatInstanceProperty(_context2 = _Object$entries(newClasses)).call(_context2));
};